import { ViewEncapsulation } from '@angular/core';
import { MainService } from './../../../Services/service.service';
import { AddPremiumAdTokenResponse } from './../../../api/WickedApiClient';
import { SubscribtionService } from './../../../Services/subscribtion.service';
import { Component, OnInit } from '@angular/core';


export enum AdView { Advertisement = 0, Payment = 1 }

@Component({
  selector: 'app-mobile-buy-third-party',
  templateUrl: './buy-third-party.component.html',
  styleUrls: ['./buy-third-party.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class MobileBuyThirdPartyComponent implements OnInit {

  constructor(public services: MainService, private subscriptionService: SubscribtionService,) { }

  ngOnInit() {

  }
}
